<template>
  <b-container fluid>
    <div class="mt-5 font-jumper NavTechnicalUser_vue">
      <h5 v-if="!navUser && !errorMsg">
        Betöltés folyamatban...
      </h5>
      <div
          v-if="errorMsg"
          class="alert alert-danger" role="alert"
      >
        {{ errorMsg }}
      </div>
      <div
          v-if="savePending"
          class="alert alert-info" role="alert"
      >
        “Kérlek várj, az adatok ellenőrzése folyamatban van…”
      </div>
      <div
          v-if="success"
          class="alert alert-success" role="alert"
      >
        “Sikeres nav bekötés!”
      </div>

      <div class="font-jumper" v-if="navUser && !savePending">

        <b-card v-if="navUser.partOfGroup">
          Csoportos adószámmal rendelkező ügyfél esetén az NAV adatkapcsolat létrehozása manuálisan történik. Ezt már elvégeztük, ezért amennyiben módosításra van szükség, kérjük, vedd fel a kapcsolatot az ügyfélszolgálattal.
        </b-card>
        <div v-else class="p-0">

          <div v-if="navUser.loginName && !showNewForm" class="border rounded-lg p-4 mb-5">
            <h5 class="mb-3">NAV felhasználó</h5>
            <div class="row">
              <div class="col-6">
                <b-form-input
                    class="profile-input-field mb-2"
                    type="text"
                    v-model="navUser.loginName"
                    readonly
                ></b-form-input>
              </div>
              <div class="col-6 text-right">
                <b-button
                    variant="primary"
                    @click="startNewNav"
                >Új NAV bekötés
                </b-button>
              </div>
            </div>
          </div>



          <div v-else class="border rounded-lg p-4 mb-5">
            <b-row class="mt-2">
              <b-col sm="12" lg="12" order-lg="1" class="pl-2">
                <b-col
                    v-for="item in navFields"
                    :key="item.prop"
                    class="profile-input-container mb-3"
                    cols="12"
                    lg="10"
                    sm="12"
                >
                  <h5 class="bold">{{ item.label }}</h5>
                  <b-form-input
                      class="profile-input-field"
                      v-if="item.type"
                      :type="item.prop === 'password' ? 'password' : 'text'"
                      :id="getId(item)"
                      :name="getInputName(item)"
                      :autocomplete="getAutocomplete(item)"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      readonly
                      data-form-type="other"
                      data-lpignore="true"
                      data-1p-ignore="true"
                      data-bwignore="true"
                      data-dashlane-ignore="true"
                      v-model="newNavUser[item.prop]"
                      trim
                      v-mask="item.mask"
                      @focus="enableManualInput"
                      @blur="disableAutoFillAgain"
                  ></b-form-input>
                  <div style="color: red" v-if="getNavError(validationError, item.prop)">
                    {{ getNavError(validationError, item.prop) }}
                  </div>
                </b-col>



                <b-col cols="12" lg="10" sm="12">
                  <b-button
                      variant="primary"
                      class="d-block mx-auto mr-lg-0"
                      @click="saveNav"
                  >
                    {{ $cte("common.save") }}
                  </b-button>
                </b-col>
              </b-col>
            </b-row>
            <div class="row">
              <div class="col-12 col-md-8">
                <div class="my-3">
                  <div class="mt-3 font-poppins">Ha segítségre van szükséged, olvasd el kapcsolódó <a
                      href="https://acounto.com/nav-onlineszamla/" target="_blank">blogposztunkat</a>.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
  </b-container>
</template>

<script>
import Api from "api-client";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'NavTechnicalUser',
  components: {},
  data() {
    return {
      navFields: [
        {
          label: "Felhasználónév",
          prop: "loginName",
          type: "text",
          mask: "XXXXXXXXXXXXXXX",
        },
        {
          label: "Jelszó",
          prop: "password",
          type: "text",
        },
        {
          label: "XML aláírókulcs",
          prop: "userSignatureKey",
          type: "text",
        },
      ],
      navUser: undefined,
      newNavUser: {},
      showNewForm: false,
      navInputToken: Math.random().toString(36).slice(2),
      errorMsg: undefined,
      validationError: undefined,
      savePending: false,
      success: false
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  methods: {
    ...mapActions("app", ["login"]),
    getId(item) {
      return "" + item.prop + "Input";
    },
    getInputName(item) {
      return `nav-${item.prop}-${this.navInputToken}`;
    },
    getAutocomplete(item) {
      return `new-${item.prop}-${this.navInputToken}`;
    },
    enableManualInput(event) {
      event.target.removeAttribute('readonly');
    },
    disableAutoFillAgain(event) {
      event.target.setAttribute('readonly', 'readonly');
    },
    saveNav() {
      this.savePending = true;
      this.errorMsg = undefined;
      this.validationError = undefined;
      this.success = false;

      Api.saveNavTechnicalUser(this.getActiveCompany.id, this.newNavUser)
          .then(() => {
            this.success = true;
            this.getNavUser();
          })
          .catch((err) => {
            if (err?.response?.data && Array.isArray(err.response.data)) {
              this.validationError = err.response.data;
            } else {
              this.errorMsg = err?.response?.data?.message || 'Ismeretlen hiba';
            }
          })
          .finally(() => this.savePending = false);
    },
    startNewNav() {
      this.newNavUser = {};
      this.showNewForm = true;
      this.validationError = undefined;
      this.errorMsg = undefined;
      this.success = false;
    },
    getNavUser() {
      this.navUser = undefined;
      this.showNewForm = false;
      this.newNavUser = {};

      Api.getNavTechnicalUser(this.getActiveCompany.id)
          .then((resp) => {
            this.navUser = resp.data;
            this.errorMsg = undefined;
          })
          .catch((err) => {
            this.errorMsg = JSON.stringify('Nem sikerült betölteni az adatokat.');
            console.error(err);
          });
    },

    getNavError(validationErrors, fieldName) {
      if (validationErrors && validationErrors) {
        const msg = validationErrors.find(error => error.field === fieldName);
        if (msg) {
          return msg.errors[0].errorMessage;
        }
      }

      return undefined;
    }
  },
  mounted() {
    this.getNavUser();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
